import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import PropTypes from 'prop-types';
import React from 'react';
import locale from '../locale/Localization';

/**
 * ConfirmDeletionDialog function.
 * @param {P} props
 * @return {Function} the employee delete dialog function.
 */
export default function ConfirmationDialog(props) {
  return (
    <Dialog
      open={props.open}
      onClose={props.handleClose}
      aria-labelledby='alert-dialog-title'
      aria-describedby='alert-dialog-description'
    >
      <DialogTitle id='alert-dialog-title'>{props.title}</DialogTitle>
      <DialogContent>
        <DialogContentText id='alert-dialog-description' component='div'>
          {props.dialogText}
          <ul>
            {props.detailList !== undefined &&
              props.detailList.map((detail, index) => {
                return <li key={index}>{detail}</li>;
              })}
          </ul>
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button
          onClick={props.handleClose}
          color='primary'
          variant='outlined'
          autoFocus
        >
          {locale.cancelButton}
        </Button>
        <Button
          onClick={props.handleSubmit}
          color='primary'
          variant='contained'
        >
          {locale.confirmButton}
        </Button>
      </DialogActions>
    </Dialog>
  );
}

ConfirmationDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  dialogText: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  handleClose: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  detailList: PropTypes.array
};
